import railcardsModal from './eurail-railcards-modal.html';
import railcardsCardnumberModal from './eurail-railcards-cardnumber-modal.html';
import {SIZE_LARGE} from '../../common/modal/modal-service';

const DIRECTIVE_NAME = EuRailRailcardsModal.DIRECTIVE_NAME = 'ktEuRailRailcardsModal';
export default function EuRailRailcardsModal() {
    return {
        restrict: 'A',
        controller: EuRailRailcardsModalController,
        controllerAs: 'euRailRailcardsModalContr',
        scope: {
            passenger: `=${DIRECTIVE_NAME}Passenger`,
        },
        link: function($scope, $elem, $attrs, euRailRailcardsModalContr) {
            $elem.on('click', () => {
                euRailRailcardsModalContr.openEuRailRailcardsModal();
            });
        },
    };
}

export function EuRailRailcardsModalController(
    $scope,
    $uibModalStack,
    modalService,
    euRailRailcardsModalService,
    eurailCardsService,
) {
    'ngInject';

    const vm = this;

    const vendorExpanded = {};
    let originalRailcards;

    Object.assign(vm, {
        $onInit,
        openEuRailRailcardsModal,
        addCard,
        toggleVendorExpansion,
        vendorExpanded,
        onSearchTextChange,
    });

    function $onInit() {
    }

    function toggleVendorExpansion(vendor) {
        vendorExpanded[vendor] = !vendorExpanded[vendor];
    }

    function onSearchTextChange() {
        const searchText = $scope.euRailRailcardsModalContr.searchText;
        if (!searchText) {
            $scope.railcards = originalRailcards;
            for (const vendor in originalRailcards) {
                vendorExpanded[vendor] = false;
            }
        } else {
            const filteredVendors = {};
            for (const vendor in originalRailcards) {
                const filteredCards = originalRailcards[vendor].filter((cardType) => cardType.Name.toLocaleLowerCase().includes(searchText.toLocaleLowerCase()));
                if (filteredCards.length > 0) {
                    filteredVendors[vendor] = filteredCards;
                    vendorExpanded[vendor] = true;
                }
            }
            $scope.railcards = filteredVendors;
        }
    }

    function addCard(cardType) {
        const existingCard = _.find($scope.passenger.cards, (card) => card.type.Code === cardType.Code);
        if (existingCard) {
            if (cardType.HasNumber) {
                $scope.cardType = cardType;
                $scope.numberChange = eurailCardsService.numberChange;
                $scope.cardNumber = existingCard.number;
                $scope.saveCard = eurailCardsService.saveCard;
                $scope.deleteCard = eurailCardsService.deleteCard;
                $scope.isEdit = true;
                modalService.openModal({
                    template: railcardsCardnumberModal,
                    scope: $scope,
                    size: SIZE_LARGE,
                });
            }
        } else if (!cardType.HasNumber) {
            eurailCardsService.addCardToPassenger(cardType, '', $scope.passenger, null);
        } else {
            $scope.cardType = cardType;
            $scope.numberChange = eurailCardsService.numberChange;
            $scope.cardNumber = '';
            $scope.isEdit = false;
            $scope.addCardToPassenger = eurailCardsService.addCardToPassenger;
            modalService.openModal({
                template: railcardsCardnumberModal,
                scope: $scope,
                size: SIZE_LARGE,
            });
        }
    }

    function openEuRailRailcardsModal() {
        euRailRailcardsModalService.getRailcards()
            .then((railcards) => {
                originalRailcards = railcards;
                $scope.railcards = railcards;
                modalService.openModal({
                    template: railcardsModal,
                    scope: $scope,
                    size: SIZE_LARGE,
                });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/eurail-railcards-modal/eurail-railcards-modal-component.js